export const WarmUpSectionInput = [
  {
    label: "Exercise #1",
    type: "text",
    placeholder: "Plan name",
    valueKey: "name",
    defaultValue: "Exercise name not found",
  },
  {
    label: "Exercise type: Normal/ Superset/ Dropset",
    type: "select",
    options: ["Normal", "Superset", "Dropset"],
    valueKey: "exercise_type",
    defaultValue: "Select exercise type",
  },
  {
    label: "Weighted",
    type: "text",
    placeholder: "Yes/No",
    valueKey: "weighted",
    defaultValue: "Weighted info not found",
  },
  {
    label: "Sets",
    type: "text",
    placeholder: "Select category",
    valueKey: "sets",
    defaultValue: "Sets info not found",
  },
  {
    label: "Reps",
    type: "text",
    placeholder: "Select category",
    valueKey: "reps",
    defaultValue: "Reps info not found",
  },
  {
    label: "Time Based",
    type: "text",
    placeholder: "Yes/No",
    valueKey: "time_based",
    defaultValue: "Time based info not found",
  },
  {
    label: "Set Time",
    type: "text",
    placeholder: "60 Sec",
    valueKey: "set_time",
    defaultValue: "Set time not found",
  },
  {
    label: "Rest Time",
    type: "text",
    placeholder: "60 Sec",
    valueKey: "rest_time",
    defaultValue: "Rest time not found",
  },
  {
    label: "Video URL",
    type: "text",
    placeholder: "Enter video URL",
    valueKey: "video_url",
  },
  {
    label: "Image URL",
    type: "text",
    placeholder: "Enter image URL",
    valueKey: "image_url",
  }
];
